import { updateAllQueries } from 'api/urql/helpers/mutation';
import getPaginatedPositions from 'queries/positions/getPaginatedPositions';

export const archivePosition = (results, args, cache, info) => {
  updateAllQueries({
    fieldName: 'paginatedPositions',
    query: getPaginatedPositions.query,
  })(results, args, cache, info);
};
